import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import { Spacer } from '@cbhq/cds-web/layout';
import { GlobalFooterContext } from '../../context/GlobalFooterContext.js';
import { titleMessages } from '../../messages.js';
import { messages } from '../../shared/messages/navigation.js';
import { DefaultSupportRoutes, GermanRoutes, statusUrl } from '../../shared/utils/links.js';
import CDSFooterLink from '../CDSFooterLink.js';
import FooterColumn from './FooterColumn.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
const getRoute = (basePath, locale = 'en', path) => {
  let localeSpecificRoutes = {};
  const defaultSupportRoutes = DefaultSupportRoutes;

  // Initialize locale specific routes
  switch (locale) {
    case 'de':
      localeSpecificRoutes = GermanRoutes;
      break;
  }

  // If we have a locale specific route, return it
  if (localeSpecificRoutes[path]) {
    return localeSpecificRoutes[path];
  }
  const defaultBasePath = defaultSupportRoutes[basePath];
  const defaultPath = path ? defaultSupportRoutes[path] : '';
  return `${defaultBasePath}${defaultPath}`;
};
function SupportColumn() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalFooterContext),
    userLocaleInfo = _useContext.userLocaleInfo;
  const locale = userLocaleInfo?.localeFromUrl;
  return /*#__PURE__*/jsxs(FooterColumn, {
    heading: formatMessage(messages.support),
    children: [/*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.helpCenter),
      href: getRoute('helpCenterUrl', locale),
      children: formatMessage(messages.helpCenter)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.contactUs),
      href: getRoute('helpCenterUrl', locale, 'contactUsUrl'),
      children: formatMessage(messages.contactUs)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.createAccount),
      href: getRoute('helpCenterUrl', locale, 'createAccountUrl'),
      children: formatMessage(messages.createAccount)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.idVerification),
      href: getRoute('helpCenterUrl', locale, 'idVerificationUrl'),
      children: formatMessage(messages.idVerification)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.accountInformation),
      href: getRoute('helpCenterUrl', locale, 'accountInformationUrl'),
      children: formatMessage(messages.accountInformation)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.paymentMethods),
      href: getRoute('helpCenterUrl', locale, 'paymentMethodsUrl'),
      children: formatMessage(messages.paymentMethods)
    }), /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(CDSFooterLink, {
        accessibilityLabel: formatMessage(titleMessages.accountAccess),
        href: getRoute('helpCenterUrl', locale, 'accountAccessUrl'),
        children: formatMessage(messages.accountAccess)
      }), /*#__PURE__*/jsx(Spacer, {
        vertical: 0.5
      }), /*#__PURE__*/jsx(CDSFooterLink, {
        accessibilityLabel: formatMessage(titleMessages.supportedCrypto),
        href: getRoute('helpCenterUrl', locale, 'supportedCryptoUrl'),
        children: formatMessage(messages.supportedCrypto)
      })]
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.status),
      href: statusUrl,
      children: formatMessage(messages.status)
    })]
  });
}
const SupportColumn$1 = /*#__PURE__*/memo(SupportColumn);
export { SupportColumn$1 as default };
//# sourceMappingURL=SupportColumn.js.map
